// Catálogo completo La Clínica del Lente

export const WHATSAPP_NUMBER = "56985754039";

export const formatPrice = (n) =>
  typeof n === "number" ? `$${n.toLocaleString("es-CL")} CLP` : "";

// ——— Marcos ópticos básicos — todos a $24.990 ———
const BASIC_IMAGES = [
  "https://www.lens.cl/cdn/shop/files/p-rx52685119-1-c05acd8e-480e-4671-8175-7458f5d522f2_cc641304-1f1c-4303-8bb0-2eb29d35bd36.jpg?v=1735272917&width=1200",
  "https://www.lens.cl/cdn/shop/files/p-rx70465364-1-d18570d8-a05e-4793-9a4b-d1eb12eea6c2.jpg?v=1735272456&width=1200",
  "https://www.lens.cl/cdn/shop/files/p-rx70465365-1-c008226b-a1a0-43ff-b720-447f53bc81de.jpg?v=1735273357&width=1200",
  "https://www.lens.cl/cdn/shop/files/p-rx4340v2000-1-d921ee88-69e1-4f09-ac1f-f6297970a1a3.png?v=1735282627&width=1200",
  "https://www.lens.cl/cdn/shop/files/p-rx3447v2500-1-f3392300-5619-45f2-8ad6-550437344c83.jpg?v=1735272609&width=1200",
  "https://www.lens.cl/cdn/shop/files/p-rx73308320-1-82b14f87-6f49-4f90-9e5f-920b5aa9d63a_8e7dd339-de45-4799-a492-ebd18c74fdfe.jpg?v=1735321678&width=1200",
  "https://www.lens.cl/cdn/shop/files/p-rx63752944-1-171154b6-b4d3-425d-9cc6-4d375d65f742_4146978c-d649-4960-be60-388de9fcac53.jpg?v=1735300536&width=1200",
  "https://www.lens.cl/cdn/shop/files/p-rx64482500-1-6878dcef-da97-49bf-8b53-8fae139c77c1.jpg?v=1735265698&width=1200",
  "https://www.lens.cl/cdn/shop/files/p-rx64482501-1-f333145f-2f39-406b-b3d5-3a2e296ad4b4.jpg?v=1735292346&width=1200",
  "https://www.lens.cl/cdn/shop/files/p-ra7020541-1-d8977e9b-50f9-4d3c-bec1-49b9da498650.jpg?v=1735312416&width=1200",
  "https://www.lens.cl/cdn/shop/files/p-an717401-1-5186239b-6471-4c47-a7e9-b5de523dadca_843d6ef5-c388-480d-ae55-dd47ae1c3f55.jpg?v=1735310954&width=1200",
  "https://www.lens.cl/cdn/shop/files/p-fz8014d509-1-58977754-e123-434f-9cb9-3d8fe9d42d60_6c6b5b25-deb9-4087-9f1b-4a35f01e3b17.jpg?v=1735332703&width=1200",
  "https://www.lens.cl/cdn/shop/files/p-fz8002u501-1-3d97c03a-a282-4d60-866d-9a16fbb8599b.jpg?v=1735321119&width=1200",
  "https://www.lens.cl/cdn/shop/files/p-fz8001u509-1-d288935c-e6d9-4ac8-977e-a2ebe682d9c6.jpg?v=1735322650&width=1200",
  "https://www.lens.cl/cdn/shop/files/p-fz8007u505-1-5ade4291-0831-4e06-82e6-4d57fa3823e0_c1f64320-7e2c-4e65-a742-c397661c78f7.jpg?v=1735325837&width=1200",
  "https://www.lens.cl/cdn/shop/files/p-fz8003u508-1-cb337677-2b24-411e-8649-95f795ad5a94.jpg?v=1735319005&width=1200",
];

const BASIC_NAMES = [
  "Marco Urban Black", "Marco Havana Classic", "Marco Panto Matte",
  "Marco Round Gold", "Marco Wayfarer Ease", "Marco Metal Arista",
  "Marco Zena Light", "Marco Pure Black", "Marco Hex Arista",
  "Marco Hex Gris", "Marco Ralph Daily", "Marco Murazzi Sport",
  "Marco FZ Racing", "Marco FZ Urban", "Marco FZ Titanium",
  "Marco FZ Matte", "Marco FZ Rect", "Marco Boutique Neo",
];

export const basicFrames = BASIC_NAMES.map((name, i) => ({
  id: `basic-${String(i + 1).padStart(3, "0")}`,
  brand: "Colección Esencial",
  name,
  description: "Marco unisex · incluye estuche y paño",
  price: 24990,
  image: BASIC_IMAGES[i % BASIC_IMAGES.length],
  alt: name,
  category: "optico",
  kind: "basico",
}));

// ——— Marcos con 1 clip (sol magnético) — $34.990 · 15 modelos ———
export const clip1Frames = Array.from({ length: 15 }).map((_, i) => ({
  id: `clip1-${String(i + 1).padStart(3, "0")}`,
  brand: "Clip Magnético · 1 pieza",
  name: `Marco Clip Duo ${String.fromCharCode(65 + i)}`,
  description: "Incluye 1 clip solar magnético · estuche y paño",
  price: 34990,
  image: BASIC_IMAGES[(i + 2) % BASIC_IMAGES.length],
  alt: `Marco con clip ${i + 1}`,
  category: "optico",
  kind: "clip1",
}));

// ——— Marcos con 5 clips — $39.990 · 10 modelos ———
export const clip5Frames = Array.from({ length: 10 }).map((_, i) => ({
  id: `clip5-${String(i + 1).padStart(3, "0")}`,
  brand: "Clip Multicolor · 5 piezas",
  name: `Marco Clip Multi ${String.fromCharCode(65 + i)}`,
  description: "Incluye 5 clips intercambiables · estuche y paño",
  price: 39990,
  image: BASIC_IMAGES[(i + 5) % BASIC_IMAGES.length],
  alt: `Marco con 5 clips ${i + 1}`,
  category: "optico",
  kind: "clip5",
}));

// ——— Lentes deportivos — 10 modelos · $39.990 ———
const SPORT_IMAGES = [
  "https://images.unsplash.com/photo-1577803645773-f96470509666?auto=format&fit=crop&w=900&q=85",
  "https://images.unsplash.com/photo-1572635196237-14b3f281503f?auto=format&fit=crop&w=900&q=85",
  "https://www.lens.cl/cdn/shop/files/p-rb3925004r6-1-89e57eba-2052-4392-82c3-96fd6dbca236.jpg?v=1771776197&width=1200",
  "https://www.lens.cl/cdn/shop/files/p-rb0832s902r5-1-568e0b1d-e9c3-4e0d-b1c9-c9976f93e8a6.jpg?v=1771777049&width=1200",
  "https://images.unsplash.com/photo-1508296695146-257a814070b4?auto=format&fit=crop&w=900&q=85",
  "https://www.lens.cl/cdn/shop/files/p-an717401-1-5186239b-6471-4c47-a7e9-b5de523dadca_843d6ef5-c388-480d-ae55-dd47ae1c3f55.jpg?v=1735310954&width=1200",
  "https://www.lens.cl/cdn/shop/files/p-fz8014d509-1-58977754-e123-434f-9cb9-3d8fe9d42d60_6c6b5b25-deb9-4087-9f1b-4a35f01e3b17.jpg?v=1735332703&width=1200",
  "https://www.lens.cl/cdn/shop/files/p-fz8007u505-1-5ade4291-0831-4e06-82e6-4d57fa3823e0_c1f64320-7e2c-4e65-a742-c397661c78f7.jpg?v=1735325837&width=1200",
  "https://www.lens.cl/cdn/shop/files/p-rb4473d71483-1-c733f5c5-8e33-43a0-a2bb-72c27d2eef84.jpg?v=1771777229&width=1200",
  "https://www.lens.cl/cdn/shop/files/p-rb4474d71087-1-14e5456c-dcc8-4cb2-b9b4-a9e68ee8c059.jpg?v=1771777270&width=1200",
];

export const sportFrames = Array.from({ length: 10 }).map((_, i) => ({
  id: `sport-${String(i + 1).padStart(3, "0")}`,
  brand: "Deportivo Performance",
  name: `Deportivo ${["Trail", "Cycle", "Run", "Alpine", "Ocean", "Peak", "Strike", "Ridge", "Sprint", "Flex"][i]}`,
  description: "Agarre goma · liviano · estuche y paño incluidos",
  price: 39990,
  image: SPORT_IMAGES[i],
  alt: `Lente deportivo ${i + 1}`,
  category: "deportivo",
  kind: "deportivo",
}));

// ——— Lentes Flexit para niños / seguridad — 10 modelos · $39.990 ———
const KIDS_IMAGES = [
  "https://images.unsplash.com/photo-1586953208448-b95a79798f07?auto=format&fit=crop&w=900&q=85",
  "https://images.unsplash.com/photo-1591076482161-42ce6da69f67?auto=format&fit=crop&w=900&q=85",
  "https://www.lens.cl/cdn/shop/files/p-ra7020541-1-d8977e9b-50f9-4d3c-bec1-49b9da498650.jpg?v=1735312416&width=1200",
  "https://www.lens.cl/cdn/shop/files/p-rx73308320-1-82b14f87-6f49-4f90-9e5f-920b5aa9d63a_8e7dd339-de45-4799-a492-ebd18c74fdfe.jpg?v=1735321678&width=1200",
  "https://www.lens.cl/cdn/shop/files/p-rx64482500-1-6878dcef-da97-49bf-8b53-8fae139c77c1.jpg?v=1735265698&width=1200",
  "https://www.lens.cl/cdn/shop/files/p-rx52685119-1-c05acd8e-480e-4671-8175-7458f5d522f2_cc641304-1f1c-4303-8bb0-2eb29d35bd36.jpg?v=1735272917&width=1200",
  "https://www.lens.cl/cdn/shop/files/p-rx70465364-1-d18570d8-a05e-4793-9a4b-d1eb12eea6c2.jpg?v=1735272456&width=1200",
  "https://www.lens.cl/cdn/shop/files/p-rx70465365-1-c008226b-a1a0-43ff-b720-447f53bc81de.jpg?v=1735273357&width=1200",
  "https://www.lens.cl/cdn/shop/files/p-rx4340v2000-1-d921ee88-69e1-4f09-ac1f-f6297970a1a3.png?v=1735282627&width=1200",
  "https://www.lens.cl/cdn/shop/files/p-rx3447v2500-1-f3392300-5619-45f2-8ad6-550437344c83.jpg?v=1735272609&width=1200",
];

export const kidsFrames = Array.from({ length: 10 }).map((_, i) => ({
  id: `flexit-${String(i + 1).padStart(3, "0")}`,
  brand: "Flexit · Niños / Seguridad",
  name: `Flexit ${["Mini", "Kids", "Junior", "Safe", "Play", "Color", "Tiny", "Soft", "Pro", "Guard"][i]}`,
  description: "Marco flexible irrompible · seguridad óptica · estuche y paño",
  price: 39990,
  image: KIDS_IMAGES[i],
  alt: `Flexit niños ${i + 1}`,
  category: "flexit",
  kind: "flexit",
}));

// ——— Lentes de sol (se mantienen los reales de lens.cl) ———
export const sunglassesProducts = [
  {
    id: "sun-rb-zuri-rb4455",
    brand: "Ray-Ban", name: "Lentes de Sol Zuri RB4455",
    description: "Nueva colección · incluye estuche y paño", price: 138900,
    image: "https://www.lens.cl/cdn/shop/files/p-rb4455667771-1-55d42316-248a-48d6-a3ba-6d8fa024c819.jpg?v=1771776285&width=1200",
    alt: "Ray-Ban Zuri RB4455", category: "sol",
  },
  {
    id: "sun-rb-rb4473d-pol",
    brand: "Ray-Ban", name: "Lentes de Sol Polarizados RB4473D",
    description: "Polarizado · UV400 · estuche y paño", price: 168900,
    image: "https://www.lens.cl/cdn/shop/files/p-rb4473d71483-1-c733f5c5-8e33-43a0-a2bb-72c27d2eef84.jpg?v=1771777229&width=1200",
    alt: "Ray-Ban RB4473D", category: "sol",
  },
  {
    id: "sun-rb-rb2225-deg1",
    brand: "Ray-Ban", name: "Lentes de Sol Degradados RB2225",
    description: "Cristal degradé · cat-eye · incluye estuche", price: 156900,
    image: "https://www.lens.cl/cdn/shop/files/p-rb2225667532-1-4b285f48-ee2c-4e51-8ea5-a9d2cb11276c.jpg?v=1771777250&width=1200",
    alt: "Ray-Ban RB2225 deg", category: "sol",
  },
  {
    id: "sun-rb-rb4474d",
    brand: "Ray-Ban", name: "Lentes de Sol RB4474D",
    description: "Líneas rectas · unisex · estuche y paño", price: 138900,
    image: "https://www.lens.cl/cdn/shop/files/p-rb4474d71087-1-14e5456c-dcc8-4cb2-b9b4-a9e68ee8c059.jpg?v=1771777270&width=1200",
    alt: "Ray-Ban RB4474D", category: "sol",
  },
  {
    id: "sun-rb-aviator-max",
    brand: "Ray-Ban", name: "Lentes de Sol Aviator Max RB3925",
    description: "Icónico aviator · incluye estuche y paño", price: 174900,
    image: "https://www.lens.cl/cdn/shop/files/p-rb3925004r6-1-89e57eba-2052-4392-82c3-96fd6dbca236.jpg?v=1771776197&width=1200",
    alt: "Aviator Max RB3925", category: "sol",
  },
  {
    id: "sun-rb-mega-wayfarer",
    brand: "Ray-Ban", name: "Lentes de Sol Mega Wayfarer II RB0832S",
    description: "Mega Wayfarer II · statement · estuche y paño", price: 174900,
    image: "https://www.lens.cl/cdn/shop/files/p-rb0832s902r5-1-568e0b1d-e9c3-4e0d-b1c9-c9976f93e8a6.jpg?v=1771777049&width=1200",
    alt: "Mega Wayfarer II", category: "sol",
  },
  {
    id: "sun-rb-rb2225",
    brand: "Ray-Ban", name: "Lentes de Sol RB2225",
    description: "Cuadrado · cristal oscuro · estuche incluido", price: 146900,
    image: "https://www.lens.cl/cdn/shop/files/p-rb222590131-1-15aba6bd-a677-457d-82bc-2e809d71282f.jpg?v=1771776861&width=1200",
    alt: "Ray-Ban RB2225", category: "sol",
  },
];

export const repairServices = [
  { id: "rep-001", name: "Cambio de bisagra", price: 4990, detail: "Bisagra de repuesto + ajuste. Incluye limpieza profunda de cortesía." },
  { id: "rep-002", name: "Barillas (patillas completas)", price: 6500, detail: "Par de barillas nuevas, adaptación al marco e incluye limpieza profunda de cortesía." },
  { id: "rep-003", name: "Reposición de barilla", price: 4000, detail: "Reemplazo de una barilla. Incluye limpieza profunda de cortesía." },
  { id: "rep-004", name: "Soldadura", price: 7990, priceFrom: true, detail: "Soldadura de marco metálico o puente. Desde $7.990. Incluye limpieza profunda de cortesía." },
  { id: "rep-005", name: "Cambio de cristales", price: 0, quoteOnly: true, detail: "Adaptación de cristales ópticos o solares al marco que ya amas (se cotiza según medida)." },
  { id: "rep-006", name: "Cambio de plaquetas", price: 0, quoteOnly: true, detail: "Plaquetas nuevas de silicona o titanio (se cotiza según modelo)." },
];

// ——— Opciones del configurador ———
export const crystalTypeOptions = [
  { value: "organico", label: "Orgánico" },
  { value: "filtro-azul", label: "Filtro azul" },
  { value: "fotocromatico", label: "Fotocromático" },
];

export const focalOptions = [
  { value: "mono-focal", label: "Mono focal" },
  { value: "bifocal", label: "Bifocal" },
  { value: "multifocal", label: "Multifocal" },
];

export const colorOptions = [
  { value: "sin-color", label: "Sin color" },
  { value: "gris", label: "Gris" },
  { value: "cafe", label: "Café" },
];
